import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SettingsModal from './SettingsModal.jsx';
import EventCalendar from './EventCalendar.jsx';
import Feed from '../Feed/Feed.jsx';
import useFullAccess from '../common/useFullAccess.js';
import { statusWithDays, awayAvatarStyle } from '../common/statusUtils.js';
import { logoutUser } from '../../redux/authSlice';

/* Определяем: телефон или десктоп */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isMobile;
};

const Profile = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [showSettings, setShowSettings] = useState(false);
  const isMobile = useIsMobile();
  const fullAccess = useFullAccess();

  return (
    <div style={{ padding: '20px' }}>
      {/* Карточка профиля */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px', background: 'rgba(255,255,255,0.65)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.4)', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', flexWrap: 'wrap' }}>
        <img
          src={user?.photoURL || 'https://via.placeholder.com/100'}
          alt="Avatar"
          style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover', border: '3px solid #2a5298', background: '#eee', ...awayAvatarStyle(user) }}
        />
        <div style={{ flex: 1, minWidth: '180px' }}>
          <h2 style={{ margin: 0 }}>{user?.displayName || user?.email?.split('@')[0] || 'Пользователь'}</h2>
          <p style={{ margin: '4px 0 0 0', color: '#666' }}>{statusWithDays(user)}</p>
          <p style={{ margin: '4px 0 0 0', color: '#999', fontSize: '13px' }}>{user?.email}</p>
        </div>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button
            onClick={() => setShowSettings(true)}
            style={{ padding: '10px 18px', background: '#f0f2f5', color: '#333', border: '1px solid #ddd', borderRadius: '20px', cursor: 'pointer', fontWeight: 600 }}
          >
            ⚙️ Настройки
          </button>
          <button
            onClick={() => dispatch(logoutUser())}
            style={{ padding: '10px 18px', background: '#ffebee', color: '#c62828', border: '1px solid #ffcdd2', borderRadius: '20px', cursor: 'pointer', fontWeight: 600 }}
          >
            🚪 Выйти
          </button>
        </div>
      </div>

      {showSettings && <SettingsModal user={user} onClose={() => setShowSettings(false)} />}

      {/* КАЛЕНДАРЬ СОБЫТИЙ — только на десктопе */}
      {!isMobile && (
        <div style={{ marginTop: '20px' }}>
          <EventCalendar />
        </div>
      )}

      {/* На телефоне лента показывается на странице профиля */}
            {isMobile && fullAccess && (
        <div style={{ marginTop: '20px' }}>
          <Feed />
        </div>
      )}
    </div>
  );
};

export default Profile;